/** Normalize a commission string for the API. Empty or invalid → null. */
export function normalizeCommissionForApi(raw: unknown): string | null {
  const s = (raw ?? '').toString().trim().replace(/\s*%$/, '').replace(',', '.').trim()
  if (!s) return null
  const n = Number(s)
  if (!Number.isFinite(n) || n < 0 || n > 100) return null
  return String(n)
}

/** Empty commission is allowed; a filled value must parse as 0–100. */
export function isCommissionInputValid(raw: unknown): boolean {
  const s = (raw ?? '').toString().trim()
  if (!s) return true
  return normalizeCommissionForApi(raw) != null
}
